import { SelectedOption } from '@/types'
import { OptionSummary, OptionSummaryWrapper, SessionName } from '@/components/SelectedSessionSummary.styles'
import { formatCurrency } from '@big-red-group/storefront-common-checkout'
import { useContext } from 'react'
import { BookingContext } from '@/context/BookingContext'
import { centsToDollars } from '@big-red-group/storefront-common-checkout'

const SelectedSessionSummary: React.FC<{ sessionName: string; selectedOptions: SelectedOption[] }> = ({
  sessionName,
  selectedOptions,
}) => {
  const { useRedemptionLayout } = useContext(BookingContext)
  return (
    <>
      <SessionName>{sessionName}</SessionName>
      {!useRedemptionLayout && (
        <OptionSummaryWrapper>
          {selectedOptions?.map((option) => {
            return (
              <OptionSummary key={option.id}>
                {option.quantity} x {option?.name} @ {formatCurrency(centsToDollars(option.price))}
              </OptionSummary>
            )
          })}
        </OptionSummaryWrapper>
      )}
    </>
  )
}

export default SelectedSessionSummary
